export default __webpack_public_path__ + "locales/vi/WebPlugins.json?hash=a0bc28a7684a694e1b1a754b280c4ba3";